import * as React from "react";
import type { SVGProps } from "react";
const SvgLifeBuoy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.637 4.223a1 1 0 0 0-1.414 1.414zm2.826 5.654a1 1 0 0 0 1.414-1.414zm7.074 4.246a1 1 0 0 0-1.414 1.414zm2.826 5.654a1 1 0 0 0 1.414-1.414zm-4.24-11.314a1 1 0 0 0 1.414 1.414zm5.654-2.826a1 1 0 0 0-1.414-1.414zm-.71.71a1 1 0 0 0-1.414-1.414zM4.223 18.363a1 1 0 1 0 1.414 1.414zm5.654-2.826a1 1 0 0 0-1.414-1.414zM21 12a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm3 9a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5zm-3 3a3 3 0 0 1-3-3H7a5 5 0 0 0 5 5zm-3-3a3 3 0 0 1 3-3V7a5 5 0 0 0-5 5zm3-3a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5zM4.223 5.637l4.24 4.24 1.414-1.414-4.24-4.24zm9.9 9.9 4.24 4.24 1.414-1.414-4.24-4.24zm1.414-5.66 4.24-4.24-1.414-1.414-4.24 4.24zm0 0 3.53-3.53-1.414-1.414-3.53 3.53zm-9.9 9.9 4.24-4.24-1.414-1.414-4.24 4.24z"
    />
  </svg>
);
export default SvgLifeBuoy;
